import { FunctionComponent } from 'react';
import { Route, Switch, Redirect } from 'react-router-dom';
import authorizationService from 'common/services/security/authorizationService';
import userTokenService from 'common/services/security/userTokenService';

import ContentHubPage from './ContentHubPage';
import featureFlags from '../../common/helpers/featureFlags';

const ContentHubPageRouter: FunctionComponent = () => {
  const hasValidToken = authorizationService.hasValidToken();
  const isInternalUser = userTokenService.isUserInternal();

  let ContentHubRoute = <Redirect to="/" />;

  if (
    (featureFlags.isContentHubEnabledForClients &&
      hasValidToken &&
      featureFlags.isContentHubEnabled) ||
    (!featureFlags.isContentHubEnabledForClients &&
      hasValidToken &&
      featureFlags.isContentHubEnabled &&
      isInternalUser)
  ) {
    ContentHubRoute = <ContentHubPage />;
  }

  return (
    <>
      <Switch>
        <Route exact path="/projects/:projectId/content-hub">
          {ContentHubRoute}
        </Route>
      </Switch>
    </>
  );
};

export default ContentHubPageRouter;
